import { handleError } from '@slr/shared-library';
import { API_SOLUTION1_SERVICE_URL } from 'configs';
import { useCallback } from 'react';
import useGetApiConfig from '../useGetApiConfig';
import { OrganizationDeletionEligibility } from './organizationDeletionEligibility.types';

export const useOrganizationDeletionEligibilityApi = () => {
  const apiConfig = useGetApiConfig(API_SOLUTION1_SERVICE_URL, false);

  const getOrganizationDeletionEligibility = useCallback(
    async (organizationId: string) => {
      const accessToken =
        typeof apiConfig.accessToken === 'function'
          ? await apiConfig.accessToken()
          : apiConfig.accessToken;

      const response = await fetch(
        `${apiConfig.basePath}/admin/organizations/${encodeURIComponent(organizationId)}/deletion-eligibility`,
        {
          headers: {
            Accept: 'application/json',
            ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
          }
        }
      );

      if (!response.ok) {
        let message = response.statusText;
        try {
          const errorBody = await response.json();
          message = errorBody?.message || errorBody?.detail || message;
        } catch {
          // ignore parse errors
        }
        const error = new Error(message) as Error & { status?: number };
        error.status = response.status;
        throw error;
      }

      return (await response.json()) as OrganizationDeletionEligibility;
    },
    [apiConfig]
  );

  return {
    getOrganizationDeletionEligibility: (organizationId: string) =>
      getOrganizationDeletionEligibility(organizationId).catch(handleError)
  };
};
